import { createBrowserRouter, type RouteObject } from "react-router-dom";

import { AppLayout } from "@/components/layout/app-layout";
import { AuthGate } from "@/components/layout/auth-gate";
import { AnnouncementsPage } from "@/pages/announcements-page";
import { DashboardPage } from "@/pages/dashboard-page";
import { DeliveriesPage } from "@/pages/deliveries-page";
import { LoginPage } from "@/pages/login-page";
import { NotFoundPage } from "@/pages/not-found-page";
import { UserDetailPage } from "@/pages/user-detail-page";
import { UsersPage } from "@/pages/users-page";

export const routes: RouteObject[] = [
  { path: "/login", element: <LoginPage /> },
  {
    element: <AuthGate />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: "users", element: <UsersPage /> },
          { path: "users/:id", element: <UserDetailPage /> },
          { path: "deliveries", element: <DeliveriesPage /> },
          { path: "announcements", element: <AnnouncementsPage /> },
          { path: "*", element: <NotFoundPage /> },
        ],
      },
    ],
  },
];

export const createAppRouter = () => createBrowserRouter(routes);
